export const COMMON_BASE_LAYERS: {
	title: string
	id: string
}[] = [
	{
		title: 'OSM',
		id: 'osm',
	},
	{
		title: 'ArcGis satellite',
		id: 'arggis',
	},
	{
		title: 'Google',
		id: 'google1',
	},
	{
		title: 'Google satellite',
		id: 'google2',
	},
	{
		title: 'Yandex',
		id: 'yandex1',
	},
	{
		title: 'Yandex satellite',
		id: 'yandex2',
	},
]
